import Component from "@ember/component"
import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import _ from "lodash"

export default class ContainerUnit extends Component {
  /**
   * Related Models
   */
  @service("ember-store") store

  @service appState

  @computed("unitId")
  get unit() {
    class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

    let model = this.useStudentVersion ? "class-website-lesson" : "card-stack"
    let promise = this.store.find(model, this.unitId)
    return ObjectPromiseProxy.create({ promise: promise })
  }

  @computed("course.attributes.calendar.version", "unitId")
  get unitInfo() {
    return _.find(get(this, "course.attributes.calendar.units"), {
      id: this.unitId,
    })
  }

  @computed("course.id", "dateString")
  get componentId() {
    return "single-unit-" + get(this, "course.id") + "-" + this.unitId
  }
}
